module.exports = __webpack_public_path__ + "static/media/25-14.772de527.mp3";